/*El component notification d'Ant Design implementa els següents tipus de notificació:
success, error, info, warning (o warn), close i destroy*/
import { notification } from "antd";

import {
  ALTURA_NOTIFICACIO_EN_PIXELS,
  MISSATGE_NO_VALOR_MODIFICAT,
  MISSATGE_EXTENSIONS_PERMESES,
  MISSATGE_TRIAR_DATES,
  MISSATGE_TRIAR_ESPECIE,
  MISSATGE_TRIAR_FENOFASE,
  MISSATGE_NO_OBSERVACIONS_TROBADES,
  MISSATGE_ERROR_DATA_ACTUAL,
  MISSATGE_NO_PARAMETRES_CANVIATS,
  MISSATGE_ERROR_FOTO,
  MISSATGE_FITXER_INCORRECTE,
  MISSATGE_NO_CONSULTA_OBSERVACIONS_DIA
} from "../constantsFormularis";

notification.config({
  top: ALTURA_NOTIFICACIO_EN_PIXELS,
  duration: 10
});

/**
 * @param tipus {String}
 * @param missatge {String}
 * @param descripcio {String}
 * @param class {String}
 * @returns function
 */
const crearNotificacio = (tipus, missatge, descripcio) => {
  const parametresNotificacio = {
    message: missatge,
    description: descripcio,
    className: "notificacio"
  };

  return notification[tipus](parametresNotificacio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioSuccess = (titol, descripcio) => {
  return crearNotificacio("success", titol, descripcio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioWarning = (titol, descripcio) => {
  return crearNotificacio("warning", titol, descripcio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioError = (titol, descripcio) => {
  return crearNotificacio("error", titol, descripcio);
};

/**
 * Crea una notificació per indicar que no s'han modificat valors en un formulari
 * @returns function
 */
export const crearNotificacioNoShanModificatValorsAlFormulari = () => {
  const notificacioCapValorModificatAdvertencia = MISSATGE_NO_VALOR_MODIFICAT;
  return crearNotificacioWarning(notificacioCapValorModificatAdvertencia);
};

/**
 * Crea una notificació per indicar que la foto seleccionada supera la mida permesa
 * @param midaFitxer {String}
 * @param unitatImatge {String}
 * @param midaMaximaPermesaImatge {String}
 * @returns function
 */
export const crearNotificacioFotoSuperaMidaPermesa = (
  midaFitxer,
  unitatImatge,
  midaMaximaPermesaImatge
) => {
  const notificacioFotoSuperaMidaPermesaAdvertencia = `La mida de la foto (${midaFitxer} ${unitatImatge}) excedeix el límit permés de ${midaMaximaPermesaImatge} ${unitatImatge}.`;
  return crearNotificacioWarning(notificacioFotoSuperaMidaPermesaAdvertencia);
};

/**
 * Crea una notificació per indicar que el nom del fitxer supera la mida permesa
 * @param midaFitxer {String}
 * @param midaNomFitxerPermesa {String}
 * @returns function
 */
export const crearNotificacioNomFitxerMidaPermesa = (
  midaNomFitxer,
  midaNomFitxerPermesa
) => {
  const notificacioNomFitxerMidaPermesaAdvertencia = `La mida del nom del fitxer: ${midaNomFitxer} excedeix el límit permés de ${midaNomFitxerPermesa} caràcters.`;
  return crearNotificacioWarning(notificacioNomFitxerMidaPermesaAdvertencia);
};

export const crearNotificacioNomFitxerRepetit = nomFitxer => {
  const notificacioNomFitxerRepetitAdvertencia = `El fitxer ${nomFitxer} ja està sel·leccionat.`;
  return crearNotificacioWarning(notificacioNomFitxerRepetitAdvertencia);
};

/**
 * Crea una notificació per indicar que la foto seleccionada s'ha carregat incorrectament'
 * @returns function
 */
export const crearNotificacioFitxerIncorrecte = () => {
  const notificacioFitxerIncorrecteAdvertencia = MISSATGE_FITXER_INCORRECTE;
  return crearNotificacioWarning(notificacioFitxerIncorrecteAdvertencia);
};

/**
 * Crea una notificació per indicar que la foto seleccionada té una extensió no permesa
 * @returns function
 */
export const crearNotificacioFotoTipusNoPermes = () => {
  const notificacioFotoTipusNoPermesAdvertencia = MISSATGE_EXTENSIONS_PERMESES;
  return crearNotificacioWarning(notificacioFotoTipusNoPermesAdvertencia);
};

/**
 * Crea una notificació per indicar error en la foto seleccionada
 * @returns function
 */
export const crearNotificacioFotoError = () => {
  const notificacioFotoTipusNoPermesAdvertencia = MISSATGE_ERROR_FOTO;
  return crearNotificacioError(notificacioFotoTipusNoPermesAdvertencia);
};

/**
 * Crea una notificació per indicar que no s'han modificat dades del formulari'
 * @returns function
 */
export const crearNotificacioDadesNoCanviades = () => {
  const notificacioDadesNoCanviadesAdvertencia = MISSATGE_NO_VALOR_MODIFICAT;
  return crearNotificacioWarning(notificacioDadesNoCanviadesAdvertencia);
};

/**
 * Crea una notificació per indicar que al formulari faltes dades obligatories.'
 * @returns function
 */
export const crearNotificacioFormulariFaltenDadesObligatories = () => {
  const notificacioFaltenDadesObligatoriesAdvertencia =
    "Falten dades obligatòries.";
  return crearNotificacioWarning(notificacioFaltenDadesObligatoriesAdvertencia);
};

/**
 * Crea una notificació per indicar el periode màxim que es pot seleccionar
 * @param periode {Number}
 * @returns function
 */
export const crearNotificacioSuperaPeriodeMaxim = periode => {
  const notificacioExcedeixPeriodeMaximAdvertencia = `La data inicial ha de ser anterior o igual a la data final amb un màxim de ${periode} dies`;
  return crearNotificacioWarning(notificacioExcedeixPeriodeMaximAdvertencia);
};

/**
 * Crea una notificació per indicar que s'ha d'informar les dates obligatòriament
 * @returns function
 */
export const crearNotificacioDatesObligatories = () => {
  const notificacioDatesObligatoriesAdvertencia = MISSATGE_TRIAR_DATES;
  return crearNotificacioWarning(notificacioDatesObligatoriesAdvertencia);
};

/**
 * Crea una notificació per indicar que s'ha d'informar l'especie obligatòriament
 * @returns function
 */
export const crearNotificacioEspecieObligatoria = () => {
  const notificacioEspecieObligatoriesAdvertencia = MISSATGE_TRIAR_ESPECIE;
  return crearNotificacioWarning(notificacioEspecieObligatoriesAdvertencia);
};

/**
 * Crea una notificació per indicar que s'ha d'informar la fenofase obligatòriament
 * @returns function
 */
export const crearNotificacioFenofaseObligatoria = () => {
  const notificacioFenofaseObligatoriesAdvertencia = MISSATGE_TRIAR_FENOFASE;
  return crearNotificacioWarning(notificacioFenofaseObligatoriesAdvertencia);
};

/**
 * Crea una notificació per indicar que no hi ha observacions amb els paràmetres de cerca informats
 * @returns function
 */
export const crearNotificacioNoObservacions = () => {
  const notificacioNoObservacionsAdvertencia = MISSATGE_NO_OBSERVACIONS_TROBADES;
  return crearNotificacioWarning(notificacioNoObservacionsAdvertencia);
};

/**
 * Crea una notificació per indicar que no s'ha recuperat la data actual.'
 * @returns function
 */
export const crearNotificacioErrorDataActual = () => {
  const notificacioErrorDataActualAdvertencia = MISSATGE_ERROR_DATA_ACTUAL;
  return crearNotificacioError(notificacioErrorDataActualAdvertencia);
};

/**
 * Crea una notificació per indicar que no s'han canviat els parámetres de cerca.'
 * @returns function
 */
export const crearNotificacioParametresNoCanviats = () => {
  const notificacioErrorDadesNoCanviades = MISSATGE_NO_PARAMETRES_CANVIATS;
  return crearNotificacioWarning(notificacioErrorDadesNoCanviades);
};

/**
 * Crea una notificació per indicar que no es poden consultar/inserir observacions pel dia escollit.'
 * @returns function
 */
export const crearNotificacioNoConsultaInsercioObservacionsDiaEscollit = () => {
  return crearNotificacioWarning(MISSATGE_NO_CONSULTA_OBSERVACIONS_DIA);
};
